import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Mail } from "@material-ui/icons";
import * as APIStore from "../../store/APIStore";
import ProgramAdministrator from "./ProgramAdministrator";
import Typography from "@material-ui/core/Typography";

const PhysicianNameComponent = (props: any) => {
    let { patientEncounterId } = props;
    let contact: APIStore.HNIProviderContact = props.ProviderContact;

    const history = useHistory();

    const handleNameClick = (email: string) => {
        history.push("/compose-new-message", { receiverId: email });
    };

    let { displayName, email, type } = contact;

    if (type.toLowerCase().startsWith('program')) {
        return (
            <ProgramAdministrator patientEncounterId={patientEncounterId} ProviderContact={contact} />
        );
    }


    if (email == "support@hnihc.com") {
        return (<React.Fragment>
            <strong>{type}:{" "}</strong>
            <Typography variant="body2" component="span" gutterBottom="100">
                {displayName}
            </Typography>


        </React.Fragment>)
    }


    return (
        <React.Fragment>
            <strong>{type}:{" "}</strong>
            <Typography variant="body2" component="span" gutterBottom="100">
                {displayName}
            </Typography>


            <Button color="primary"
                onClick={() => {

                    handleNameClick(email);
                }}
                startIcon={<Mail />}
            >


            </Button>
        </React.Fragment>
    );
};

export default PhysicianNameComponent;
